import { createContext, useState, useContext } from "react";
import { getTokenClinicDoctor } from "../utils/commonUtils";

const PatientContext = createContext();

export const usePatientContext = () => useContext(PatientContext);

export const PatientContextProvider = ({ children }) => {
  const [patientAppData, setPatientAppData] = useState({
    clinicDetails: {},
    doctors: {},
  });

  const savePatientAppData = (key, data) => {
    setPatientAppData((prevData) => ({
      ...prevData,
      [key]: data,
    }));
  };

  const getPatientAppData = (key, defaultVal = null) => {
    return patientAppData[key] || defaultVal;
  };

  const context = {
    patientAppData,
    savePatientAppData,
    getPatientAppData,
  };

  return (
    <PatientContext.Provider value={context}>
      {children}
    </PatientContext.Provider>
  );
};

export default PatientContext;
